/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LeagueCategoryEnum } from '../models/LeagueCategoryEnum';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MicrosoftPowerBiService {
    /**
     * Insider Amount
     * @param key
     * @returns any Successful Response
     * @throws ApiError
     */
    public static insiderAmountPowerBiNewInsidersGet(
        key: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/power_bi/new_insiders',
            query: {
                'key': key,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Claimed Players
     * @param key
     * @param leagueCategory
     * @returns any Successful Response
     * @throws ApiError
     */
    public static claimedPlayersPowerBiClaimedPlayersGet(
        key: string,
        leagueCategory?: (LeagueCategoryEnum | null),
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/power_bi/claimed_players',
            query: {
                'key': key,
                'league_category': leagueCategory,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Lineup Amount
     * @param key
     * @returns any Successful Response
     * @throws ApiError
     */
    public static lineupAmountPowerBiLineupAmountGet(
        key: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/power_bi/lineup_amount',
            query: {
                'key': key,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Event Amount
     * @param key
     * @returns any Successful Response
     * @throws ApiError
     */
    public static eventAmountPowerBiEventAmountGet(
        key: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/power_bi/event_amount',
            query: {
                'key': key,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Teams With Players
     * @param key
     * @returns any Successful Response
     * @throws ApiError
     */
    public static teamsWithPlayersPowerBiTeamsWithPlayersGet(
        key: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/power_bi/teams_with_players',
            query: {
                'key': key,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Registered Users Old
     * @param key
     * @returns any Successful Response
     * @throws ApiError
     */
    public static registeredUsersOldPowerBiRegisteredUsersOldGet(
        key: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/power_bi/registered_users_old',
            query: {
                'key': key,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Registered Users
     * @param key
     * @param startDate
     * @returns any Successful Response
     * @throws ApiError
     */
    public static registeredUsersPowerBiRegisteredUsersGet(
        key: string,
        startDate?: (string | null),
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/power_bi/registered_users',
            query: {
                'key': key,
                'start_date': startDate,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Insider Scores
     * @param key
     * @returns any Successful Response
     * @throws ApiError
     */
    public static insiderScoresPowerBiInsiderScoresGet(
        key: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/power_bi/insider_scores',
            query: {
                'key': key,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Man Of The Match Votes
     * @param key
     * @returns any Successful Response
     * @throws ApiError
     */
    public static manOfTheMatchVotesPowerBiManOfTheMatchVotesGet(
        key: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/power_bi/man_of_the_match_votes',
            query: {
                'key': key,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Device Count
     * @param key
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deviceCountPowerBiDeviceCountGet(
        key: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/power_bi/device_count',
            query: {
                'key': key,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
